module.exports = __webpack_public_path__ + "img/veg.4993a5e1.svg";